module.exports = __webpack_public_path__ + "img/gps.0d0d81e8.png";